import axiosClient from './axiosClient';

export interface KnowledgeFolderDto {
  id: string;
  name: string;
  description: string;
  sortOrder: number;
  articleCount: number;
  createdAt: string;
}

export interface KnowledgeArticleDto {
  id: string;
  folderId?: string;
  folderName?: string;
  title: string;
  description?: string;
  fileName?: string;
  fileType?: string;
  fileSizeBytes?: number;
  storageKey?: string;
  createdById?: string;
  createdBy?: string;
  createdAt: string;
}

export const knowledgeApi = {
  getFolders: async (): Promise<KnowledgeFolderDto[]> => {
    const response = await axiosClient.get('/knowledge/folders');
    return response.data;
  },

  getArticlesByFolder: async (folderId: string): Promise<KnowledgeArticleDto[]> => {
    const response = await axiosClient.get(`/knowledge/folders/${folderId}/articles`);
    return response.data;
  },

  uploadArticle: async (
    file: File,
    folderId: string | null,
    title?: string,
    description?: string,
  ): Promise<KnowledgeArticleDto> => {
    const formData = new FormData();
    formData.append('file', file);
    if (folderId) formData.append('folderId', folderId);
    if (title) formData.append('title', title);
    if (description) formData.append('description', description);
    const response = await axiosClient.post('/knowledge/articles/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteArticle: async (articleId: string): Promise<void> => {
    await axiosClient.delete(`/knowledge/articles/${articleId}`);
  },

  /** Returns a blob URL for inline preview (caller must revoke when done). */
  getPreviewBlobUrl: async (articleId: string): Promise<string> => {
    const response = await axiosClient.get(`/knowledge/articles/${articleId}/stream`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },

  /** Downloads an article file via the stream endpoint with auth headers. */
  downloadArticle: async (articleId: string, fileName: string): Promise<void> => {
    const response = await axiosClient.get(`/knowledge/articles/${articleId}/stream`, {
      params: { download: true },
      responseType: 'blob',
    });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
};
